import { render, staticRenderFns } from "./Eye.vue?vue&type=template&id=2347a08e&"
import script from "./Eye.vue?vue&type=script&lang=js&"
export * from "./Eye.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports